// extracted by mini-css-extract-plugin
export default {"category":"Section_category__em8v8","button":"Section_button__qeo2S","sectionTitle":"Section_sectionTitle__8AsbA"};